import { supabase } from '@/integrations/supabase/client';

/** Count a submitted/completed project once, whether owned or shared, in this cohort only. */
export async function loadProjectMilestoneComplete(userId: string, cohortId: string): Promise<boolean> {
  const [owned, collaborations] = await Promise.all([
    supabase.from('participant_projects').select('id, status, submitted')
      .eq('user_id', userId).eq('cohort_id', cohortId),
    supabase.from('project_collaborators').select('project_id').eq('user_id', userId),
  ]);
  if (owned.error) throw owned.error;
  if (collaborations.error) throw collaborations.error;

  const sharedIds = [...new Set((collaborations.data ?? []).map(row => row.project_id))];
  let projects = owned.data ?? [];
  if (sharedIds.length > 0) {
    const shared = await supabase.from('participant_projects').select('id, status, submitted')
      .eq('cohort_id', cohortId).in('id', sharedIds);
    if (shared.error) throw shared.error;
    projects = [...projects, ...(shared.data ?? [])];
  }
  return projects.some(project => project.submitted === true || project.status === 'completed');
}